export const helperText = "Helper text example";

export const labelValueOptions: LabelValue[] = ["Artist", "Representative", "Label Manager"].map((value) => ({
  label: value,
  value,
}));
